module.exports = {"320508017":"白洋湾街道","320508018":"平江街道","320508019":"金阊街道","320508020":"沧浪街道","320508021":"双塔街道","320508022":"虎丘街道","320508023":"苏锦街道","320508024":"吴门桥街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320508.json
// module id = 966
// module chunks = 0